export default __webpack_public_path__ + "static/media/constellations_responsive.7554282d.png";